var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogContent, Typography } from "@mui/material";
import { ModalActionButton, ModalActions, ModalLoadingButton } from "../../../../Shared/components/modalTemplates";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { MealSizeText, SelectionModeOptions } from "./MealSizeModule-Types";
export const createAllMealSizeOption = (text) => ({ RecipeSizeId: -1, CompanyId: -1, Size: text });
export const getDefaultMealSize = (DefaultSelectionMode, SubscriptionMeals, ProgramMeals, MealSizes) => {
    let payload = undefined;
    // If the default selection is not defined, return undefined.
    if (!DefaultSelectionMode || DefaultSelectionMode === SelectionModeOptions.None) {
        payload = undefined;
    }
    // Select size of the meal that has the most quantity as the default.
    else if (DefaultSelectionMode === SelectionModeOptions.MostMealQuantity) {
        // Find matching program meals to get recipe size ids.
        const subMealsWithSize = SubscriptionMeals.filter((sm) => sm.Quantity > 0).map((meal) => {
            var _a;
            const recipeSizeId = (_a = ProgramMeals.find((pm) => pm.ProgramMealId === meal.ProgramMealId)) === null || _a === void 0 ? void 0 : _a.RecipeSizeId;
            return {
                ProgramMealId: meal.ProgramMealId,
                Quantity: meal.Quantity,
                RecipeSizeId: recipeSizeId !== null && recipeSizeId !== void 0 ? recipeSizeId : -1,
            };
        });
        const sizeQuantityMap = [];
        // Find quantity of each meal size.
        subMealsWithSize.map((mealWithSize) => {
            const size = sizeQuantityMap.find((size) => size.recipeSizeId === mealWithSize.RecipeSizeId);
            if (size) {
                size.quantity += mealWithSize.Quantity;
            }
            else {
                sizeQuantityMap.push({ recipeSizeId: mealWithSize.RecipeSizeId, quantity: mealWithSize.Quantity });
            }
        });
        const mostSelectedMealSize = sizeQuantityMap === null || sizeQuantityMap === void 0 ? void 0 : sizeQuantityMap.sort((prevMeal, currentMeal) => prevMeal.quantity - currentMeal.quantity).at(-1);
        payload = mostSelectedMealSize
            ? MealSizes.find((ms) => ms.RecipeSizeId === mostSelectedMealSize.recipeSizeId)
            : undefined;
    }
    return payload;
};
// The "Confirm" button in the warning modal (resets the chosen meals when the meal size is changed and if meals have been selected).
export const curriedWarningModalOnClick = (dispatch, mealSize) => () => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: ActionTypes.SET_MEAL_SIZE, payload: Object.assign({}, mealSize) });
    dispatch({ type: ActionTypes.SET_TEMPLATE, payload: [] });
    dispatch({ type: ActionTypes.SET_MEAL_BUNDLE, payload: [] });
    return true;
});
// The content section of the warning modal. It accepts one parameter for the modal title.
export const warningModalContent = (warningModalText) => (_jsx(DialogContent, { children: _jsx(Typography, { children: warningModalText ? warningModalText : MealSizeText.DEFAULT_WARNING_TEXT }) }));
// The actions component for the warning modal. It accepts two parameters for the onClick function.
export const warningModalActions = (dispatch, mealSize) => {
    return (_jsxs(ModalActions, { children: [_jsx(ModalActionButton, Object.assign({ color: "secondary", variant: "outlined" }, { children: MealSizeText.CANCEL })), _jsx(ModalLoadingButton, Object.assign({ color: "secondary", variant: "contained", onClick: curriedWarningModalOnClick(dispatch, mealSize) }, { children: MealSizeText.CONFIRM }))] }));
};
// The warning modal is called within the meal size change function (showModal).
// The content and actions components are built separately.
export const curriedHandleMealSizeChange = (mealSizesToRender, storeCartMealSize, template, storeCartMeals, ClearMealsOnMealSizeChanged, showModal, dispatch) => (MealSizeId, mealSizeChangeWarningTitle, mealSizeChangeWarningDefaultText) => () => {
    var _a;
    const mealSize = mealSizesToRender.find((ms) => ms.RecipeSizeId === MealSizeId);
    if (!storeCartMealSize || !mealSize || storeCartMealSize.RecipeSizeId != (mealSize === null || mealSize === void 0 ? void 0 : mealSize.RecipeSizeId)) {
        if ((template.length > 0 || storeCartMeals.length > 0) && ClearMealsOnMealSizeChanged != null) {
            const warningModalText = (_a = ClearMealsOnMealSizeChanged.TextValue) !== null && _a !== void 0 ? _a : mealSizeChangeWarningDefaultText;
            showModal({
                title: mealSizeChangeWarningTitle,
                content: (_jsx(DialogContent, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: warningModalText })) })),
                actions: warningModalActions(dispatch, mealSize),
            });
        }
        else {
            dispatch({ type: ActionTypes.SET_MEAL_SIZE, payload: Object.assign({}, mealSize) });
            dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
        }
    }
};
export const getMealSizesToRender = (MealSizes, MealSizesToIgnore) => MealSizes.filter((mealSize) => {
    if (!MealSizesToIgnore)
        return true;
    return !MealSizesToIgnore.includes(mealSize.RecipeSizeId);
});
